// ============================================================================
// HAI Reporting Tool - Role-Based Redirect Component
// Redirects users to appropriate landing page based on their role
// ============================================================================

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function RoleBasedRedirect() {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - go to login
  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  // No profile yet - wait
  if (!userProfile) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          <p className="mt-4 text-gray-600">Loading profile...</p>
        </div>
      </div>
    );
  }

  // Role-based redirect
  if (userProfile.role === 'Admin') {
    return <Navigate to="/admin/dashboard" replace />;
  } else {
    // All non-admin users go to simple data entry
    return <Navigate to="/entry" replace />;
  }
}
